/**
 * Gorilla Netting storefront helpers.
 * Warehouse theme: patch ITORIS DPO price selectors so updatePrice() can write totals.
 */
(function () {
  'use strict';

  var WAREHOUSE_PRICE =
    '.product-form .price-list .price, .shopify-section--main-product .price-list .price';
  var WAREHOUSE_COMPARE =
    '.product-form .price-list .price--compare, .shopify-section--main-product .price-list .price--compare';
  var WAREHOUSE_PRICE_BOX =
    '.product-form .price-list, .shopify-section--main-product .price-list';

  function gnPatchDpoPriceSelectors() {
    if (!window.dpoObserver || !dpoObserver.selectors) {
      return false;
    }
    var s = dpoObserver.selectors;
    if (s.specialPrice.indexOf('price-list') !== -1) {
      return true;
    }
    s.specialPrice = WAREHOUSE_PRICE + ', ' + s.specialPrice;
    s.regularPrice = WAREHOUSE_COMPARE + ', ' + s.regularPrice;
    s.priceBox = WAREHOUSE_PRICE_BOX + ', ' + s.priceBox;
    return true;
  }

  function gnForceDpoPriceRefresh() {
    if (!gnPatchDpoPriceSelectors()) {
      return;
    }
    if (!window.dpoOptions || typeof dpoOptions.updatePrice !== 'function') {
      return;
    }
    var dpoElm = document.getElementById('itoris_dynamicproductoptions');
    if (dpoElm) {
      dpoElm.dpoProductInitialPrices = false;
    }
    dpoOptions.lastUpdatePriceResult = false;
    dpoOptions.updatePrice(true);
  }

  function schedulePatchAttempts() {
    var attempts = 0;
    (function tick() {
      if (gnPatchDpoPriceSelectors() && window.dpoOptions) {
        gnForceDpoPriceRefresh();
        return;
      }
      if (++attempts < 80) {
        setTimeout(tick, 250);
      }
    })();
  }

  function bindDpoPriceSelectorPatch() {
    if (!window.jQuery) {
      schedulePatchAttempts();
      return;
    }
    gnPatchDpoPriceSelectors();
    jQuery(window).on('dpo_before_initialize.gnWarehousePrice', gnPatchDpoPriceSelectors);
    jQuery(window).on('dpo_initialized.gnWarehousePrice', gnForceDpoPriceRefresh);
    jQuery(document).on(
      'change.gnWarehousePrice keyup.gnWarehousePrice',
      '#itoris_dynamicproductoptions input, #itoris_dynamicproductoptions select',
      gnForceDpoPriceRefresh
    );
    schedulePatchAttempts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindDpoPriceSelectorPatch);
  } else {
    bindDpoPriceSelectorPatch();
  }
})();
